import theme from "@config/theme";

type BadgePermissionProps = {
  type: "owner" | "developer" | "viewer" | "no-access";
};

const BadgePermission = ({ type }: BadgePermissionProps) => (
  <>
    <span className={`badgePermission ${type}`} />

    <style jsx>{`
      .badgePermission {
        font-size: ${theme.fonts.size.px12};
        color: ${theme.colors.gray1};
        text-transform: uppercase;
        margin-left: 5px;
        padding: 0.15em 0.4em 0.3em 0.4em;
        font-weight: 700;
        line-height: 1;
        letter-spacing: 0.2px;
        text-align: center;
        white-space: nowrap;
        vertical-align: baseline;
        border-radius: 3px;
        transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
          border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        position: relative;
        top: -2px;
      }

      .owner {
        background-color: ${theme.colors.notehubBlueTintLightest};
      }

      .developer {
        background-color: ${theme.colors.kellyGreenTintLighter};
      }

      .viewer {
        background-color: ${theme.colors.saffronYellowTint};
      }

      .no-access {
        background-color: ${theme.colors.poppyRed};
      }

      .owner:before {
        content: "OWNER";
      }

      .developer:before {
        content: "DEVELOPER";
      }

      .viewer:before {
        content: "VIEWER";
      }

      .no-access:before {
        content: "NO ACCESS";
      }
    `}</style>
  </>
);

export default BadgePermission;
